const CANCEL_BUTTON = "actionButtonCancel";
const SAVE_BUTTON = "actionButtonSave";

export { CANCEL_BUTTON, SAVE_BUTTON };
//# sourceMappingURL=data-hooks.js.map
